import PropTypes from 'prop-types';
import React from 'react';
import { buildImagePath } from '../../../../JobComponents/Company/Image/logo';
import SponsorDisplay from '../../../SponsorDisplay/SponsorDisplay';

import './SingleEventImageDisplaySection.scss';

export default class SingleEventImageDisplaySection extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        className: PropTypes.string,
        image: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string,
        }).isRequired,
        sponsors: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                image: PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.string,
                }),
                companyId: PropTypes.number,
                description: PropTypes.string,
            })
        ).isRequired,
        injectedTransforms: PropTypes.shape({
            mainImage: PropTypes.string,
        }),
        desktopView: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        injectedTransforms: {
            mainImage: 'c_scale,f_auto,q_auto,w_260,h_194',
        },
        desktopView: false,
    };

    loadImages = () => {
        const { sponsors, image, injectedTransforms } = this.props;

        const mainImageSrc = buildImagePath(
            image.src,
            'mainImage',
            injectedTransforms
        );
        const mainImageElement = (
            <img
                className="singleEventImageDisplay-mainImage"
                src={mainImageSrc}
                alt="event-logo"
            />
        );

        // if no sponsors, only show event description image
        if (!sponsors || sponsors.length === 0) return mainImageElement;

        // if we have sponsors, show event description image with sponsors (max 3) overlaid
        return (
            <section className="imageSection">
                {mainImageElement}
                <SponsorDisplay sponsors={sponsors} />
            </section>
        );
    };

    render() {
        const { className, desktopView } = this.props;
        const desktopStyling = desktopView ? 'desktop-image-section' : '';
        return (
            <div
                className={`component-Events-SingleEventComponent-SingleEventImageDisplaySection ${className} ${desktopStyling}`}
            >
                {this.loadImages()}
            </div>
        );
    }
}
